const FEATURED_CABIN = {
  rank: '#1',
  name: 'Glen Falls Luxury Cabin in Highlands, NC',
  recommendation: 'Top Recommendation',
  tagline: 'Top-rated luxury cabin near Glen Falls waterfall',
  desc: 'Glen Falls Luxury Cabin sits in a secluded, wooded setting in Highlands, NC — private enough to feel like a true retreat, yet just a few minutes\' drive from downtown Highlands and Main Street. The cabin is within walking distance of Glen Falls waterfall, making it an easy base for both outdoor time and town. It holds a 5.0-star Airbnb Guest Favorite rating, one of the highest in the area, with guests consistently noting the upscale finishes, indoor and outdoor fireplaces, covered deck, and attentive hosting.',
  tags: ['Pet Friendly', 'Near Glen Falls', 'Indoor Fireplace', 'Outdoor Fireplace', 'Covered Deck'],
  rating: '5.0',
  href: 'https://glenfallscabin.com',
  img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/82b5623f-a9a4-4c1a-aebf-7b48fe50828d____glen-falls-luxury-cabin-fire-pit.jpg?v=1d670368f3ca182b7ebb0bf842226bc0',
};

const OTHER_CABINS = [
  {
    rank: '#2',
    name: 'Laurelwood',
    tagline: 'Charming mountain cabin in a serene wooded setting',
    desc: 'A well-rated cabin rental in Highlands, NC set among mature trees. Comfortable, peaceful, and well-located for guests who want a classic mountain escape with easy access to local trails and downtown.',
    tags: ['Wooded Setting', 'Mountain Cabin', 'Highlands, NC'],
    rating: '4.9',
    href: 'https://www.vrbo.com/9585180ha',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/8f8e8e50-db78-4f16-98ad-df783523f5fb_lauralwood.jpg?v=b217c2d0ed1fd424e03a6182cc825629',
  },
  {
    rank: '#3',
    name: 'Falls Drive Cottage',
    tagline: 'Cozy cottage steps from the waterfall trails',
    desc: 'A cozy, well-located cottage along Falls Drive — one of the most scenic roads in Highlands. A solid choice for guests who want to be close to the waterfalls and enjoy a quiet, nature-immersed stay.',
    tags: ['Near Waterfalls', 'Scenic Location', 'Cozy Cottage'],
    rating: '4.88',
    href: 'https://www.vrbo.com/9708237ha',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/2fc20e78-0610-46ea-8d08-42512d4cd546_falls-drive-cottage.jpg?v=ff1f3173554355082858f4dde89f4624',
  },
  {
    rank: '#4',
    name: 'Whispering Walk',
    tagline: 'Peaceful cabin retreat with a quiet forest setting',
    desc: 'A tranquil cabin rental in a quiet wooded neighborhood in Highlands, NC. A good fit for guests seeking privacy and calm, with easy access to the natural beauty of the surrounding area.',
    tags: ['Peaceful Setting', 'Wooded Neighborhood', 'Private Retreat'],
    rating: '4.91',
    href: 'https://www.vrbo.com/9342676ha',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/9b9a737d-38ca-412e-b0c4-550bddbd2b96_whisphering-walk.jpg?v=903da70d418fbb5ef0fe0e04a9c868aa',
  },
];

export default function NearbyCabinsSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">

        {/* Section header */}
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Verified Listings</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Top Cabin Picks in<br /><em className="italic">Highlands, NC</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-xl mx-auto mt-5">
            Here are some of the best <strong className="text-[#2D4A3E] font-medium">places to stay in Highlands, NC</strong>, based on location, amenities, and overall guest experience. Each listing is verified and linked directly to the booking page.
          </p>
        </div>

        {/* Featured cabin — Glen Falls, full-width horizontal card */}
        <article className="bg-white rounded-2xl overflow-hidden flex flex-col lg:flex-row mb-6">
          {/* Image */}
          <a
            href={FEATURED_CABIN.href}
            target="_blank"
            rel="noopener noreferrer"
            className="relative lg:w-[52%] h-72 lg:h-auto min-h-[340px] overflow-hidden shrink-0 block group cursor-pointer"
          >
            <img
              src={FEATURED_CABIN.img}
              alt={`${FEATURED_CABIN.name} — cabin in Highlands NC`}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            {/* Editor's Pick badge */}
            <div className="absolute top-4 left-4 flex items-center gap-1.5 bg-[#2D4A3E] text-white text-xs tracking-[0.15em] uppercase font-jost px-3 py-1.5 rounded-full">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-award-line text-[#C9A96E] text-xs" />
              </div>
              Editor&apos;s Pick
            </div>
            {/* Rating overlay */}
            <div className="absolute bottom-4 left-4 flex items-center gap-1.5 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-star-fill text-[#C9A96E] text-xs" />
              </div>
              <span className="text-[#1A1A18] text-xs font-jost font-semibold">{FEATURED_CABIN.rating}</span>
              <span className="text-[#9C9890] text-xs font-jost">· Guest Favorite</span>
            </div>
          </a>

          {/* Content */}
          <div className="flex-1 p-8 lg:p-10 flex flex-col justify-between">
            <div>
              <div className="flex items-start justify-between gap-3 mb-1">
                <div>
                  <span className="inline-block text-[#C9A96E] font-jost font-semibold text-sm tracking-widest mb-1">
                    {FEATURED_CABIN.rank}
                  </span>
                  <a
                    href={FEATURED_CABIN.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cursor-pointer block"
                  >
                    <h3 className="font-cormorant text-3xl text-[#1A1A18] font-medium hover:text-[#2D4A3E] transition-colors leading-tight">
                      {FEATURED_CABIN.name}
                    </h3>
                  </a>
                  <p className="text-[#2D4A3E] text-xs font-jost font-semibold tracking-[0.18em] uppercase mt-1.5 mb-0.5">
                    {FEATURED_CABIN.recommendation}
                  </p>
                  <a
                    href={FEATURED_CABIN.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-[#C9A96E] text-xs font-jost hover:text-[#B8954F] transition-colors cursor-pointer mt-1"
                  >
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-external-link-line text-xs" />
                    </div>
                    View Listing
                  </a>
                </div>
              </div>
              <p className="text-[#6B8C7D] text-xs font-jost tracking-wide uppercase mb-4 mt-3">{FEATURED_CABIN.tagline}</p>
              <p className="text-[#5C5850] text-sm font-jost leading-relaxed mb-6">{FEATURED_CABIN.desc}</p>
              <div className="flex flex-wrap gap-2 mb-8">
                {FEATURED_CABIN.tags.map((tag) => (
                  <span key={tag} className="text-xs font-jost px-3 py-1 rounded-full bg-[#EDE8E0] text-[#5C5850]">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <a
              href={FEATURED_CABIN.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#2D4A3E] text-white text-xs font-jost tracking-[0.15em] uppercase px-6 py-3 rounded-full hover:bg-[#1e3329] transition-all cursor-pointer whitespace-nowrap self-start"
            >
              View Listing
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-external-link-line text-xs" />
              </div>
            </a>
          </div>
        </article>

        {/* Other 3 cabins — grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {OTHER_CABINS.map((cabin) => (
            <article key={cabin.name} className="bg-white rounded-2xl overflow-hidden flex flex-col">
              {/* Image */}
              <a
                href={cabin.href}
                target="_blank"
                rel="noopener noreferrer"
                className="block h-52 overflow-hidden group cursor-pointer"
              >
                <img
                  src={cabin.img}
                  alt={`${cabin.name} — cabin in Highlands NC`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </a>

              {/* Content */}
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <div>
                    <span className="inline-block text-[#C9A96E] font-jost font-semibold text-xs tracking-widest mb-0.5">
                      {cabin.rank}
                    </span>
                    <a
                      href={cabin.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer block"
                    >
                      <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium hover:text-[#2D4A3E] transition-colors leading-tight">
                        {cabin.name}
                      </h3>
                    </a>
                    <a
                      href={cabin.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-[#C9A96E] text-xs font-jost hover:text-[#B8954F] transition-colors cursor-pointer mt-0.5"
                    >
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-external-link-line text-xs" />
                      </div>
                      View Listing
                    </a>
                  </div>
                  <div className="flex items-center gap-1 shrink-0">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-[#C9A96E] text-xs" />
                    </div>
                    <span className="text-[#5C5850] text-xs font-jost font-medium">{cabin.rating}</span>
                  </div>
                </div>
                <p className="text-[#6B8C7D] text-xs font-jost tracking-wide uppercase mb-3 mt-2">{cabin.tagline}</p>
                <p className="text-[#5C5850] text-sm font-jost leading-relaxed flex-1 mb-5">{cabin.desc}</p>
                <div className="flex flex-wrap gap-2 mb-5">
                  {cabin.tags.map((tag) => (
                    <span key={tag} className="text-xs font-jost px-3 py-1 rounded-full bg-[#EDE8E0] text-[#5C5850]">
                      {tag}
                    </span>
                  ))}
                </div>
                <a
                  href={cabin.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 border border-[#2D4A3E] text-[#2D4A3E] text-xs font-jost tracking-[0.15em] uppercase px-5 py-2.5 rounded-full hover:bg-[#2D4A3E] hover:text-white transition-all cursor-pointer whitespace-nowrap self-start"
                >
                  View Listing
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-external-link-line text-xs" />
                  </div>
                </a>
              </div>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
}
